import { render, staticRenderFns } from "./SendTicket.vue?vue&type=template&id=49934e5f&"
import script from "./SendTicket.vue?vue&type=script&lang=js&"
export * from "./SendTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports